/**
 * Extracts the first subdomain from the REACT_APP_API_URL environment variable.
 * @returns {string | null} The first subdomain if present, otherwise null.
 */
const getFirstSubdomain = (): string | null => {
  const { hostname } = window.location;
  const parts = hostname.split('.');

  // Handle cases like localhost or single part domains
  if (parts.length < 2 || (parts.length === 2 && parts[1] === 'localhost')) {
    return '';
  }

  const blocked = ['admin-dev', 'admin-test', 'admin', 'localhost', 'cpo', 'cpo-test', 'cpo-dev'];
  if (parts?.[0] && blocked.some((d) => parts[0].includes(d))) {
    return '';
  }

  // Return first part as subdomain
  return parts[0];
};

export default getFirstSubdomain;
